export enum UserAgencyLoginSegment {
    All = "All",
    Vehicle = "Vehicle",
    Travel = "Travel",
    CancelTravel = "CancelTravel",
    Home = "Home",
    Children = "Children",
    Life = "Life",
}